import type { PlayerRatings } from '@/api/generated/models'
import type { Rating } from '@/features/_shared/ratings'
import type { RatingSet } from '../types'

// overallFielding is intentionally omitted — the card shows the grand OVR, the
// player's own section overall (OVRb / OVRp), then position + fielding + EN.
const ATTR_KEYS = ['overall', 'overallHitting', 'overallPitching', 'po', 'fi', 'co', 'sy', 'hr', 'di', 'cn', 'ba', 'sl', 'sp', 'ra', 'gl', 'ar', 'en'] as const

export function mapRatings(api: PlayerRatings | null | undefined): RatingSet {
  if (!api) return {}
  const src = api as unknown as Record<string, Rating | undefined>
  const out: RatingSet = {}
  for (const k of ATTR_KEYS) {
    if (src[k]) (out as Record<string, Rating>)[k] = src[k] as Rating
  }
  return out
}
